import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=4b6b7b1f&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=4b6b7b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b7b1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6b7b1f')) {
      api.createRecord('4b6b7b1f', component.options)
    } else {
      api.reload('4b6b7b1f', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=4b6b7b1f&scoped=true&", function () {
      api.rerender('4b6b7b1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Orders.vue"
export default component.exports